import React, { useMemo } from 'react'
import useApp from 'hooks/useApp'

const useSecureKeypad = () => {

	const App = useApp()
	const gXKModule = useMemo(() => new window.XKModule(), [])

	const showKeypad = ({ id = "xk-pad", input, onShow, onClose, onChange, length = 6 }) => {
		
		onShow && onShow()

		gXKModule.initialize({
			name: id,
			editBox: input,
			keyType: "number",
			maxInputSize: length,
			width: 100,
			position: { top: 10, left: null },
			viewType: "half",
			numberKeyRowCount: 3,
			closeDelay: 300,
			autoKeyResize: true,
			isE2E: App.test ? false : true,
			onlyMobile: true,
			hasPressEffect: true,
			onInputChange: function (newLength) {
				// Ex. 키패드 입력 길이가 최대 입력 길이가 됐을 때 키패드 닫기
				if (newLength === length && gXKModule.isOpend()) {
					gXKModule.close();
				}
				onChange && onChange(newLength)
			},
			onKeypadClose: function () {
				// 키패드가 닫혔을 때 실행될 로직 작성
				onClose && onClose()
			},
		})
	}

	return [gXKModule, showKeypad]
}

export default useSecureKeypad